import React, { useState } from 'react'

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core'

import useSnackbar from 'hooks/useSnackbar'
import * as service from 'service'

const ConfirmDeleteDialog = ({
  open,
  enrollment,
  courseId,
  onClose,
  onSuccess,
}) => {
  const snackbar = useSnackbar()
  const [loading, setLoading] = useState(false)

  const handleConfirm = async () => {
    setLoading(true)
    try {
      await service.dponet.trainingEnrollment.destroy({
        courseId,
        enrollmentId: enrollment.id,
      })
      onSuccess()
    } catch {
      snackbar.open({ message: 'Erro ao remover aluno.', variant: 'error' })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Tem certeza que deseja remover do curso?</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Esta ação é permanente e todos os certificados vinculados a ele também
          serão removidos do sistema.
        </Typography>
        {enrollment?.user?.name && (
          <Typography variant="body1">{enrollment.user.name}</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" disabled={loading}>
          Cancelar
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="secondary"
          disabled={loading}
        >
          Excluir
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDeleteDialog
